<template>
  <b-row>
    <b-col cols="12">
      <KarmaCatalogueEditForm />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import KarmaCatalogueEditForm from './KarmaCatalogueEditForm.vue'

export default {
  components: {
    BRow,
    BCol,
    KarmaCatalogueEditForm,
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
